module.exports = global.config = {
    server_url: "https://ott-backend-streamline.onrender.com"
    // server_url : "http://localhost:7979"
    // server_url : "https://streamlineott.herokuapp.com"
}